import React from 'react';

export const mergeRefs = <T = any>(
  refs: Array<React.MutableRefObject<T> | React.Ref<T> | undefined | null>,
): React.RefCallback<T> => {
  return (value) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(value);
        continue;
      }
      if (ref) {
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    }
  };
};
